import * as R from 'ramda';
import React from 'react';
import {map, startWith} from 'rxjs/operators';

import {translate} from 'iss/strings';
import {activatedSitesByForm, searchContracts} from 'iss/service/ActivationDataService';
import subscribeTo from 'iss/utils/subscriptionUtils';
import {FormFieldLoadingError} from 'iss/widgets/Forms';
import {formatSiteAddress, formatSiteExternalId} from 'iss/widgets/format/Site';
import {SearchableSelector} from 'iss/widgets/selectors/SearchableSelector';

export const EvaluationContractSelector = subscribeToActivatedSitesByForm(props => {
  return <SimpleContractSelector selectedItemFormatter={contract => showSelectedSite(contract.site, props.isActivated(contract.site))} {...props} />;
});

export function subscribeToActivatedSitesByForm(Component) {
  return subscribeTo(
    ({hilightContractsWithActivatedForm}) => {
      return activatedSitesByForm(hilightContractsWithActivatedForm)
        .pipe(
          startWith([]),
          map(sites => ({id}) => sites.indexOf(id) != -1)
        );
    },
    'isActivated',
    Component,
    FormFieldLoadingError
  );
}

export function SimpleContractSelector({isActivated, ...props}) {
  return <SearchableSelector getItems={searchContracts} debounced={true}
    selectionIdentity={R.prop('id')} {...props} >
    {contract => {
      const activated = isActivated(contract.site);
      const activatedNotice = activated ? <div style={{color: "red", fontWeight: "bold"}}>{translate('batchEvaluationActivator.alreadyActivated').toUpperCase()}</div> : null;
      return <React.Fragment>
        <strong>{contract.site.name}</strong>
        {activatedNotice}
        <div>{formatSiteAddress(contract.site)}</div>
        <div>{formatSiteExternalId(contract.externalId)}</div>
      </React.Fragment>;
    }}
  </SearchableSelector>;
}

export function showSelectedSite(site, isActivated) {
  return <React.Fragment>
    <strong>
      {isActivated && <span style={{color: "red"}}>{translate('batchEvaluationActivator.alreadyActivated').toUpperCase()} </span>}
      {site.name}
    </strong>
    {" "}
    {formatSiteAddress(site)}
  </React.Fragment>;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/selectors/EvaluationContractSelector.jsx